export const AUDIO = 'audio';
export const VIDEO = 'video';
export const SCREENCAST = 'screenshare';
